// src/store/reducers/vtoReducer.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { base_url } from '../../utils/config'

// Thunk: fetch VTO assets for a product
export const fetchVtoAssets = createAsyncThunk(
  'vto/fetchVtoAssets',
  async (productId, { getState, rejectWithValue }) => {
    const authState = getState().auth
   const token     = authState.token || authState.userInfo?.token
    if (!token) {
      return rejectWithValue('Not authenticated')
    }
    try {
      const { data } = await axios.get(
        `${base_url}/api/product/${productId}/vto-assets`,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return data.assets   // → [{ assetUrl, assetKey, assetType }, …]
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || err.message)
    }
  }
)

const vtoSlice = createSlice({
  name: 'vto',
  initialState: {
    assets: [],
    loading: false,
    error: null
  },
  reducers: {
    clearVtoState: (state) => {
      state.assets  = []
      state.loading = false
      state.error   = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVtoAssets.pending, (state) => {
        state.loading = true
        state.error   = null
      })
      .addCase(fetchVtoAssets.fulfilled, (state, { payload }) => {
        state.loading = false
        state.assets  = payload
      })
      .addCase(fetchVtoAssets.rejected, (state, { payload }) => {
        state.loading = false
        state.error   = payload
      })
  }
})

export const { clearVtoState } = vtoSlice.actions
export default vtoSlice.reducer
